<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-input-group>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="3"
                            :state="$v.descricao.$error ? false : null"
                            @input.native="$v.descricao.$touch()"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>A descrição é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Gradação</label>
                    <b-form-select
                        :options="gradacoes"
                        v-model="gradacao"
                        text-field="descricao"
                        :state="$v.gradacao.$error ? false : null"
                         @input.native="$v.gradacao.$touch()"
                        value-field="id"
                    ></b-form-select>
                    <b-form-invalid-feedback>A gradação é obrigatória</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Dias para correção</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                            :state="$v.quantidade.$error ? false : null"
                            @input.native="$v.quantidade.$touch()"
                        ></b-form-input>
                        <b-form-invalid-feedback>O campo é obrigatório e deve ser maior que zero.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>  
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="cancelar()"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import IrregularidadesServicos from './IrregularidadesServicos'


export default {
    props: {
        irregularidade: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String,
            default: () => 'INSERÇÃO'
        }
    },

    data() {
        return {
            gradacoes: [],
            erros: [],
            gradacao: null,
            descricao: null,
            quantidade: ''
        }
    },

    created() {
    },

    mounted() {
        this.obterGradacoes()
    },

    methods: {
        cancelar() {
            this.resetForm()
            this.$emit('fechar')
        },

        resetForm() {
            this.descricao = null
            this.gradacao = 1
            this.quantidade = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        setErros(errors) {
            this.erros = errors
        },

        preencherFormulario(listaGradacoes) {
            this.descricao = this.irregularidade.descricao
            this.gradacoes = [...listaGradacoes];
            this.quantidade = this.irregularidade.diasParaCorrecao
            if (this.irregularidade.gradacao) {
                let gradacao = listaGradacoes.filter(g => g.id === this.irregularidade.numeroGradacao);
                this.gradacao = gradacao.length > 0 ? gradacao[0].id : null
            } else {
                this.gradacao = 1;
            }
        },

        obterGradacoes(){
            this.$store.dispatch('addRequest')
            IrregularidadesServicos.obterGradacoes().then(response => {
                if (response) {
                    if (response) {
                        this.preencherFormulario(response);
                    } else {
                        this.$toast.error(
                            'Erro ao obter gradações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Irregularidade',
                html: `Confirma a ${this.operacao.toLowerCase()} da irregularidade <b></b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            let irregularidadeDto = {
                idIrregularidade: this.irregularidade.idIrregularidade ? this.irregularidade.idIrregularidade : "0",
                descricao: this.descricao,
                gradacao: this.gradacao,
                diasParaCorrecao: Number(this.quantidade),
                ativa: this.irregularidade.ativa ? this.irregularidade.ativa : false,
            }
            this.$emit('salvar', irregularidadeDto)
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        arquivoOk() {
            if (this.operacao == 'INSERÇÃO') {
                return this.arquivo !== null
            }
            return true
        }
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        gradacao: {
            required
        },
        quantidade: {
            required, 
            minValue: minValue(1)
        }
    }
}
</script>
